import React, { useState, useRef } from 'react';

interface FileUploadProps {
    name: string;
    required?: boolean;
    onChange: (name: string, file: File | null) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ name, required, onChange }) => {
    const [fileName, setFileName] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0] || null;
        setFileName(file ? file.name : null);
        onChange(name, file);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        const file = e.dataTransfer.files?.[0] || null;
        setFileName(file ? file.name : null);
        onChange(name, file);
    };

    return (
        <div className='w-full'>
            <div className='bg-gray-100 w-full text-sm text-gray-800 px-4 py-3.5 rounded-md outline-accent focus:bg-transparent border border-slate-200 hover:border-slate-400 shadow-sm focus:shadow-md flex items-center justify-center cursor-pointer'
                onClick={() => fileInputRef.current?.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}>
                <input
                    type='file'
                    name={name}
                    ref={fileInputRef}
                    className='hidden'
                    onChange={handleFileChange}
                    required={required} />
                <span className='truncate text-slate-500'>
                    {fileName || 'Sleep een bestand hierheen of klik om te uploaden'}
                </span>
            </div>
        </div>
    );
};

export default FileUpload;